import { Button, CircularProgress, Divider,  TextField } from '@mui/material';
import { useRef, useEffect, useState } from 'react';
import '../css/modal.css'


const BrandAdd = ({ handleClose, token, open, handleModal, handleRefresh }) => {

    const brand_name = useRef();
    const brand_bonus_prcnt = useRef();
    const brand_bonus_unit = useRef();
    const [prodload, setProdload] = useState(false);

    const handleEscape = (e) => {
        if (e.keyCode == 27) {
            handleClose(false);
        }
    }

    useEffect(() => {
        window.addEventListener('keyup', handleEscape);
        return () => {
            window.removeEventListener('keyup', handleEscape);
        }
    }, [handleEscape])

    const handleClick = () => {
        if (open) {
            handleModal(false);
        }
    }

    const handleSubmit = () => {
        setProdload(true);
        var req = {
            'brand_name': brand_name.current.value,
            'brand_bonus_prcnt': brand_bonus_prcnt.current.value,
            'brand_bonus_unit': brand_bonus_unit.current.value
        }

        console.log(JSON.stringify(req));

        const request = new Request('https://wms-cloud.com/api/Brand' , {
        //const request = new Request('http://localhost:8080/Brand',{
            method: 'POST',
            body: JSON.stringify(req),
            headers: new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': `Bearer ${token}` })
        });

        fetch(request).then((response) => {
            if (response.status == 200) {
                console.log(response.body);
                setProdload(false);
                handleClose(false);
                handleRefresh();

            } else {
                console.log("aldaa garsan" + JSON.stringify(response));
                alert("Амжилтгүй "+ JSON.stringify(response) );
                setProdload(false);
            }
        });
    }

    return <div className="custmodal" >
    <div className="mcont">
        <div className="mheader">
            Brand Нэмэх
        <button aria-label="Хаах" onClick={() => handleClick()}>✕</button>
        </div>
        <Divider />
        <div className="mccont">
                <div className="crow">
                    <div style={{  width: "100%", paddingRight: "10px" }}>
                        <TextField inputRef={brand_name} label="Брэнд нэр" fullWidth ></TextField>
                    </div>
                </div>
                <div className="crow">
                <div style={{  width: "100%", paddingRight: "10px" }}>
                    <TextField inputRef={brand_bonus_prcnt} type="number" label="Bonus percent" fullWidth ></TextField>
                </div>
                </div>
                <div className="crow">
                <div style={{  width: "100%", paddingRight: "10px" }}>
                    <TextField inputRef={brand_bonus_unit} type="number" label="Bonus unit" fullWidth ></TextField>
                </div>
                </div>
        </div>
        <div className="mfooter">
            <Button onClick={handleClick}>Буцах</Button>
            <Button variant="contained" onClick={handleSubmit}>Хадгалах</Button>
        </div>
        {prodload ?
            <div className="prodload">
                <CircularProgress />
            </div> : ""
        }
    </div>
    </div>

}

export default BrandAdd;